import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@devinforius/i-essentials';
import { FilesService } from 'src/app/shared/services/files.service';
import { Cols } from 'src/app/shared/models/cols';
import { MailSignatureFiles } from 'src/app/shared/models/mails/mail-signature';
import { MailsFilesRefuseSignatureParams } from 'src/app/shared/models/mails/mail-file';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-document-to-sign',
  templateUrl: './document-to-sign.component.html',
  styleUrls: ['./document-to-sign.component.scss'],
})
export class DocumentToSignComponent implements OnInit {
  public columns: Cols[] = [];
  public forselection: { click: (value: MailSignatureFiles[]) => void; label: string; tooltip: string }[] = [
    {
      click: (selections) => {
        this.refuse(selections);
      },
      label: 'Refus',
      tooltip: '',
    },
  ];
  public files: MailSignatureFiles[] = [];
  public fileToShow: MailSignatureFiles = null;
  public refuseModal: boolean = false;
  public formRefuse = new FormGroup({
    justification: new FormControl<string>(null),
    dateRefus: new FormControl(new Date()),
  });
  public refusedItems: MailSignatureFiles[] = [];
  constructor(
    public toastr: ToastrService,
    public spinner: NgxSpinnerService,
    private titleService: Title,
    private translater: TranslateService,
    private filesService: FilesService
  ) {}
  ngOnInit(): void {
    this.titleService.setTitle(this.translater.translate('tabsTitle.documentsToSign'));
    this.getFilesToValidate();
    this.columns = [
      {
        field: 'mailId',
        header: 'ID',
        format: (value: number): number => {
          return value;
        },
        click: (value) => {
          this.goTo(value.mailId);
        },
      },
      {
        field: 'objet',
        header: 'Objet',
        format: (value: string): string => {
          return value;
        },
      },
      {
        field: 'serviceLabel',
        header: 'Service',
        format: (value: string): string => {
          return value;
        },
      },
      {
        field: 'documentName',
        header: 'Document',
        format: (value: string): string => {
          return value;
        },
      },
    ];
  }

  getFilesToValidate(): void {
    this.files = [];
    this.filesService.getAllFilesToSignIndividuels().subscribe({
      next: (res) => {
        if (res.length > 0) {
          res.map((item) => {
            this.files.push({
              mailId: item.mail.id,
              objet: item.mail.objet,
              serviceId: item.mail.serviceProprietaireId,
              serviceLabel: item.mail.serviceProprietaire ? item.mail.serviceProprietaire.description : '',
              documentName: item.file.description + '.' + item.file.extension,
              name: item.file.description,
              extension: item.file.extension,
              id: item.file.id,
              version: item.file.version,
            });
          });
        }
        this.files = [...this.files];
      },
    });
  }

  validateRefusal(): void {
    if (this.refusedItems.length > 0) {
      this.refusedItems.forEach((item) => {
        const params: MailsFilesRefuseSignatureParams = {
          justification: this.formRefuse.value.justification,
          dateRefus: this.formRefuse.value.dateRefus.toISOString(),
        };
        this.filesService.putRefuseSignature(item.mailId, item.id, params).subscribe({
          next: () => {
            this.refuseModal = false;
            this.toastr.success('Refus de signature effectué avec succès');
            this.getFilesToValidate();
          },
        });
      });
    }
  }
  refuse(items: MailSignatureFiles[]): void {
    if (items.length > 0) {
      this.refusedItems = items;
      this.refuseModal = true;
    }
  }

  openFile(item: MailSignatureFiles): void {
    this.fileToShow = null;
    this.fileToShow = item;
    this.spinner.show();
  }

  goTo(mailId: number): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + mailId);
  }
}
